import { FC, ReactNode } from 'react';
import cx from 'classnames';

import styles from './FieldInfoGroup.module.sass';

interface FieldInfoGroupProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

const FieldInfoGroup: FC<FieldInfoGroupProps> = ({
  title,
  description,
  actions,
  children,
}) => {
  const classes = cx(styles.group, {
    [styles['has-children']]: !!children,
  });

  return (
    <div className={classes}>
      <div className={styles.info}>
        <div className={styles.info_header}>
          {title && <div className={styles.title}>{title}</div>}
          {!title && <div className={styles.title}>&nbsp;</div>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
        {description && <div className={styles.description}>{description}</div>}
        {children && <div className={styles.info_body}>{children}</div>}
      </div>
    </div>
  );
};

export default FieldInfoGroup;
